export default [
    { name: '中文简体', code: 'zh_CN' },
    { name: '阿拉伯语', code: 'ar' },
    { name: '德语', code: 'de' },
    { name: '英文 ', code: 'en' },
    { name: '西班牙语', code: 'es' },
    { name: '法语', code: 'fr' },
    { name: '日语', code: 'ja' },
    { name: '韩语', code: 'ko' },
    { name: '葡萄牙语', code: 'pt' },
    { name: '俄语', code: 'ru' },
    { name: '中文繁体', code: 'zh_HN' },
    { name: '意大利语', code: 'it' },
    { name: '孟加拉语', code: 'bn' },
    { name: '丹麦语', code: 'da' },
    { name: '越南语', code: 'vi' },
    { name: '印尼语', code: 'idn' },
    { name: '土耳其语', code: 'tr' },
    { name: '泰语', code: 'th' },
    { name: '荷兰', code: 'nl' },
    { name: '波兰语', code: 'pl' },
    { name: '捷克语', code: 'cs' },
    { name: '爱沙尼亚语', code: 'ee' },
    { name: '芬兰语', code: 'fi' },
    { name: '希腊语', code: 'el' },
    { name: '匈牙利语', code: 'hu' },
    { name: '保加利亚语', code: 'gg' },
    { name: '克罗地亚语', code: 'hr' },
    { name: '爱尔兰语', code: 'ga' },
    { name: '罗马尼亚语', code: 'ro' },
    { name: '拉脱维亚语', code: 'lv' },
    { name: '马耳他语', code: 'mt' },
    { name: '斯洛伐克语', code: 'sk' },
    { name: '斯洛文尼亚语', code: 'si' },
    { name: '瑞典语', code: 'sv' },
    { name: '立陶宛语', code: 'lt' },
    { name: '马来语', code: 'ml' },
    { name: '缅甸语', code: 'bur' },
    { name: '老挝语', code: 'la' },
    { name: '他加禄语（菲律宾）', code: 'ph' },
    { name: '波斯语', code: 'fa' },
    { name: '泰米尔语', code: 'ta' },
    { name: '蒙语', code: 'mn' },
    { name: '哈萨克语', code: 'kk' },
    { name: '洪都拉斯', code:'hn'},
    { name: '柬埔寨语', code:'kh'},
    { name: '乌克兰语', code: 'uk' },
    { name: '印地语', code: 'hi' }
];
